import { AuthContextProps } from "react-oidc-context";
import { UserProfile, AuthTokens } from "../types/api";
import { AUTH_CONFIG } from "../config/constants";
import { IS_MOCK, MOCK_PROFILE } from "./mock";

const MOCK_ID_TOKEN = "mock-id-token";

const signOutRedirect = () => {
  const clientId = AUTH_CONFIG.clientId;
  const logoutUri = AUTH_CONFIG.postLogoutRedirectUri;
  const cognitoDomain = import.meta.env.VITE_COGNITO_DOMAIN;
  const fullLogoutRedirect = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
  console.log("Redirecting to logout URL:", fullLogoutRedirect);
  window.location.href = fullLogoutRedirect;
};

export class AuthService {
  static getAuthTokens(auth: AuthContextProps): AuthTokens {
    if (IS_MOCK) {
      return { idToken: MOCK_ID_TOKEN, accessToken: MOCK_ID_TOKEN };
    }
    return {
      idToken: auth.user?.id_token,
      accessToken: auth.user?.access_token,
    };
  }

  static getIdToken(auth: AuthContextProps): string | undefined {
    return IS_MOCK ? MOCK_ID_TOKEN : auth.user?.id_token;
  }

  static getUserProfile(auth: AuthContextProps): UserProfile {
    if (IS_MOCK) return MOCK_PROFILE;
    return {
      email: auth.user?.profile?.email,
      "cognito:groups":
        (auth.user?.profile?.["cognito:groups"] as string[]) || [],
    };
  }

  static getUserGroups(auth: AuthContextProps): string[] {
    if (IS_MOCK) return MOCK_PROFILE["cognito:groups"] ?? [];
    return (auth.user?.profile?.["cognito:groups"] as string[]) || [];
  }

  static isAdmin(auth: AuthContextProps): boolean {
    return AuthService.getUserGroups(auth).includes("admins");
  }

  static isAuthenticated(auth: AuthContextProps): boolean {
    return IS_MOCK || (auth.isAuthenticated && !!auth.user?.id_token);
  }

  static isLoading(auth: AuthContextProps): boolean {
    return IS_MOCK ? false : auth.isLoading;
  }

  static hasError(auth: AuthContextProps): boolean {
    return IS_MOCK ? false : !!auth.error;
  }

  static getError(auth: AuthContextProps): Error | null {
    return auth.error || null;
  }

  static async signOut(): Promise<void> {
    if (IS_MOCK) {
      window.location.href = "/logout-success";
      return;
    }
    signOutRedirect();
  }

  static async signIn(auth: AuthContextProps): Promise<void> {
    if (IS_MOCK) return;
    await auth.signinRedirect();
  }
}
